import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=c573ac90&scoped=true&"
import script from "./Notice.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./Notice.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./Notice.vue?vue&type=style&index=0&id=c573ac90&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c573ac90",
  null
  
)

export default component.exports